import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import LandingPage from './modules/public/LandingPage';
import LoginPage from './modules/auth/LoginPage';
import RegisterPage from './modules/auth/RegisterPage';
import CreateClientProfilePage from './modules/auth/CreateClientProfilePage';
import StaffPasswordChangePage from './modules/auth/StaffPasswordChangePage';
import HomeNursingPage from './modules/public/HomeNursingPage';
import AboutPage from './modules/public/AboutPage';
import CatalogPage from './modules/public/CatalogPage';
import ProductDetailPage from './modules/public/ProductDetailPage';
import VerifyOTPReg from './auth/VerifyOTPReg';
import { AuthProvider } from './context/AuthContext';
import ChildCarePage from './modules/public/ChildCarePage';
import ElderlyCarePage from './modules/public/ElderlyCarePage';
import DoctorVisitsPage from './modules/public/DoctorVisitsPage';
import MedicineDeliveryPage from './modules/public/MedicineDeliveryPage';
import HomeLabServicePage from './modules/public/HomeLabServicePage';
import AmbulanceServicePage from './modules/public/AmbulanceServicePage';
import PriorityMembershipPage from './modules/public/PriorityMembershipPage';
import ElderlyCareBookingPage from './modules/public/ElderlyCareBookingPage';
import PatientCarePage from './modules/public/PatientCarePage';
import PatientCareBookingPage from './modules/public/PatientCareBookingPage';
import HospitalCarePage from './modules/public/HospitalCarePage';
import HospitalCareBookingPage from './modules/public/HospitalCareBookingPage';
import BookingSuccessPage from './modules/public/BookingSuccessPage';
import WorkersTeamPage from './modules/public/service_team/WorkersTeamPage';
import WorkerRegistrationPage from './modules/public/service_team/WorkerRegistrationPage';
import WorkerRegistrationSuccessPage from './modules/public/service_team/WorkerRegistrationSuccessPage';
import StaffDocumentUploadPage from './modules/public/service_team/StaffDocumentUploadPage';
import ClientPaymentReceiptPage from './modules/public/ClientPaymentReceiptPage';
import VerifyStaffOTP from './modules/public/service_team/VerifyStaffOTP';
import WorkerDashboardDemo from './modules/public/service_team/WorkerDashboardDemo';
import ClientDashboardDemo from './modules/public/ClientDashboardDemo';
import ClientProfileDemo from './modules/public/ClientProfileDemo';
import AdminDashboard from './modules/admin/admin_dashboard_main/AdminDashboard';
import UserManagement from './modules/admin/user_managemnet/user_managemnet';
import StaffManagement from './modules/admin/user_managemnet/staff_management';
import ClientDetailPage from './modules/admin/user_managemnet/client_detail_page';
import ClientFinancialBreakdownPage from './modules/admin/user_managemnet/ClientFinancialBreakdownPage';
import ProxyUserManagement from './modules/admin/user_managemnet/proxy_user_management';
import ServiceRequests from './modules/admin/service_requests/service_requests';
import ProxyServiceRequest from './modules/admin/service_requests/proxy_service_request';
import ModularQuoteBuilder from './modules/admin/service_requests/ModularQuoteBuilder';
import WorkerVerification from './modules/admin/worker_verifications/worker_verifications';
import WorkerVerificationDetailsPage from './modules/admin/worker_verifications/WorkerVerificationDetailsPage';
import Financials from './modules/admin/financial/financial';
import BankAccounts from './modules/admin/back_accounts/bank_accounts';
import Reports from './modules/admin/reports/reports';
import SalesByCustomer from './modules/admin/reports/sales_by_customer';
import ReceivablesAging from './modules/admin/reports/receivables_aging';
import PayablesAging from './modules/admin/reports/payables_aging';
import ProfitLoss from './modules/admin/reports/profit_loss';
import BalanceSheet from './modules/admin/reports/balance_sheet';
import Settings from './modules/admin/settings/settings';
import StaffMissingBankDetails from './modules/admin/user_managemnet/staff_missing_bank_details';
import NotificationsMessages from './modules/admin/notifications/notifications_messages';
import DocumentsPage from './modules/admin/documents/documents_page';
import WhatsAppInboxPage from './modules/admin/whatsapp/whatsapp_inbox_page';
import AdminLoginPage from './modules/admin/AdminLoginPage';
import DeviceActivationPage from './modules/admin/DeviceActivationPage';
import { AdminAuthProvider } from './context/AdminAuthContext';
import ScrollToTop from './components/common/ScrollToTop';
import './App.css';
import HomeNursingBookingPage from './modules/public/HomeNursingBookingPage';
import BabyCareBookingPage from './modules/public/BabyCareBookingPage';
import StaffRoster from './modules/admin/service_requests/staff_roster';
import Bookings from './modules/admin/bookings/Bookings';
import ClientBookings from './modules/client/ClientBookings';
import TerminationRequests from './modules/admin/termination_requests/termination_requests';
import UpcomingEvents from './modules/admin/upcoming_events/UpcomingEvents';
import Statements from './modules/admin/statements/statements';
import Earnings from './modules/public/service_team/Earnings';
import AdvanceRequests from './modules/admin/advance_requests/advance_requests';
import LeaveRequests from './modules/admin/leave_requests/LeaveRequests';
import StaffWorkingHistory from './modules/admin/advance_requests/StaffWorkingHistory';
import ForgotPasswordPage from './modules/auth/ForgotPasswordPage';
import VerifyForgotPasswordOtp from './modules/auth/VerifyForgotPasswordOtp';
import ResetPasswordPage from './modules/auth/ResetPasswordPage';
import ViewStaffPage from './modules/public/ViewStaffPage';
import StaffProfile from './modules/public/StaffProfile';
import ClientProfile from './modules/client/ClientProfile';
import ClientServiceRequests from './modules/client/ClientServiceRequests';
import ClientPatients from './modules/client/ClientPatients';
import ClientQuotations from './modules/client/ClientQuotations';
import ClientReceipts from './modules/client/ClientReceipts';
import ClientInvoices from './modules/client/ClientInvoices';
import ClientStatements from './modules/client/ClientStatements';
import ClientCareTeam from './modules/client/ClientCareTeam';
import ClientFinancial from './modules/client/ClientFinancial';
import ClientReviews from './modules/client/ClientReviews';
import ClientLayout from './modules/client/components/ClientLayout';
import WorkerBookings from './modules/public/service_team/WorkerBookings';
import StaffMyProfile from './modules/public/service_team/StaffMyProfile';
import StaffChangeRequestPage from './modules/public/service_team/StaffChangeRequestPage';
import StaffLeaveRequestPage from './modules/public/service_team/StaffLeaveRequestPage';
import StaffSalarySheetsPage from './modules/public/service_team/StaffSalarySheetsPage';
import StaffReviewsPage from './modules/public/service_team/StaffReviewsPage';
import StaffCareHistoryPage from './modules/public/service_team/StaffCareHistoryPage';
import StaffPortalGuard from './modules/public/service_team/StaffPortalGuard';
import StaffAccessRevokedPage from './modules/public/service_team/StaffAccessRevokedPage';
import ChangeRequestsPage from './modules/admin/change_requests/ChangeRequestsPage';
import ActivityLogPage from './modules/admin/activity_log/ActivityLogPage';
import AdminReviewsPage from './modules/admin/reviews/AdminReviewsPage';
import QuotationsPage from './modules/admin/service_quotes/quotations';
import QuotationDetailsPage from './modules/admin/service_quotes/quotation_details';
import ServiceRequestSummaryPage from './modules/admin/service_requests/service_request_summary';
import BookingStaffRosterPage from './modules/admin/service_requests/booking_staff_roster';
import BookingStaffAssignmentPage from './modules/admin/service_requests/booking_staff_assignment';
import BookingDetailPage from './modules/admin/bookings/BookingDetailPageV2';
import BookingDetailPageV2 from './modules/admin/bookings/BookingDetailPageV2';
import StaffDetailPage from './modules/admin/user_managemnet/StaffDetailPageV2';
import StaffDetailPageV2 from './modules/admin/user_managemnet/StaffDetailPageV2';
import TotalEarningsBreakdownPage from './modules/admin/user_managemnet/TotalEarningsBreakdownPage';
import CurrentEarningsBreakdownPage from './modules/admin/user_managemnet/CurrentEarningsBreakdownPage';
import PatientsPage from './modules/admin/patients/patients';
import PatientDetailPage from './modules/admin/patients/patient_details';
import TransactionsPage from './modules/admin/transactions/TransactionsPage';
import ClientPaymentsLedgerPage from './modules/admin/payments/ClientPaymentsLedgerPage';
import StaffSalariesPage from './modules/admin/salaries/StaffSalariesPage';
import SalarySheetLedgerPage from './modules/admin/salaries/SalarySheetLedgerPage';
import StaffPermissionsPage from './modules/admin/permissions/StaffPermissionsPage';
import CustomRolesPage from './modules/admin/permissions/CustomRolesPage';
import InternalStaffPage from './modules/admin/internal_staff/InternalStaffPage';
import InternalStaffProfilePage from './modules/admin/internal_staff/InternalStaffProfilePage';
import InternalStaffSalaryPage from './modules/admin/internal_staff_salary/InternalStaffSalaryPage';
import InternalStaffSalaryBuilder from './modules/admin/internal_staff_salary/InternalStaffSalaryBuilder';
import ActiveSessionsPage from './modules/admin/active_sessions/ActiveSessionsPage';
import SalespersonsPage from './modules/admin/salespersons/SalespersonsPage';
import AdminInvoicesPage from './modules/admin/invoices/AdminInvoicesPage';
import SalespersonDetailPage from './modules/admin/salespersons/SalespersonDetailPage';
import BulkImportPage from './modules/admin/bulk_import/BulkImportPage';
import ProductsPage from './modules/admin/products/ProductsPage';
import VendorsPage from './modules/admin/vendors/VendorsPage';
import ClientProducts from './modules/client/ClientProducts';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="antialiased text-slate-900 dark:text-slate-100 bg-slate-50 dark:bg-slate-900 min-h-screen font-sans">
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<LandingPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/products" element={<CatalogPage />} />
            <Route path="/products/:productId" element={<ProductDetailPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/create-client-profile" element={<CreateClientProfilePage />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/forgot-password/verify-otp" element={<VerifyForgotPasswordOtp />} />
            <Route path="/forgot-password/reset" element={<ResetPasswordPage />} />
            <Route path="/change-staff-password" element={<StaffPasswordChangePage />} />
            <Route path="/admin" element={
              <AdminAuthProvider>
                <AdminLoginPage />
              </AdminAuthProvider>
            } />
            <Route path="/admin/activate-device" element={<DeviceActivationPage />} />
            <Route path="/verify-otp-reg" element={<VerifyOTPReg />} />
            <Route path="/services/home-nursing" element={<HomeNursingPage />} />
            <Route path="/services/home-nursing/book" element={<HomeNursingBookingPage />} />
            <Route path="/services/child-care" element={<ChildCarePage />} />
            <Route path='/services/child-care/book' element={<BabyCareBookingPage/>}/>
            <Route path="/services/elderly-care" element={<ElderlyCarePage />} />
            <Route path="/services/doctor-visits" element={<DoctorVisitsPage />} />
            <Route path="/services/ambulance" element={<AmbulanceServicePage />} />
            <Route path="/services/medicine-delivery" element={<MedicineDeliveryPage />} />
            <Route path="/services/home-lab" element={<HomeLabServicePage />} />
            <Route path="/priority-membership" element={<PriorityMembershipPage />} />
            <Route path="/services/elderly-care/book" element={<ElderlyCareBookingPage />} />
            <Route path="/services/patient-care" element={<PatientCarePage />} />
            <Route path="/services/patient-care/book" element={<PatientCareBookingPage />} />
            <Route path="/services/hospital-care" element={<HospitalCarePage />} />
            <Route path="/services/hospital-care/book" element={<HospitalCareBookingPage />} />
            <Route path="/services/view-staff" element={<ViewStaffPage />} />
            <Route path="/services/staff-profile/:id" element={<StaffProfile/>}/>
            <Route path="/booking-success" element={<BookingSuccessPage />} />
            <Route path="/services/join-team" element={<WorkersTeamPage />} />
            <Route path="/services/apply" element={<WorkerRegistrationPage />} />
            <Route path="/staff/documents/:token" element={<StaffDocumentUploadPage />} />
            <Route path="/client/pay-receipt/:token" element={<ClientPaymentReceiptPage />} />
            <Route path="/verify-staff-otp" element={<VerifyStaffOTP />} />
            <Route path="/worker-registration-success" element={<WorkerRegistrationSuccessPage />} />
            <Route path="/staff-access-revoked" element={<StaffAccessRevokedPage />} />
            <Route path="/services/provider-dashboard" element={<StaffPortalGuard><WorkerDashboardDemo /></StaffPortalGuard>} />
            <Route path="/services/earnings" element={<StaffPortalGuard><Earnings /></StaffPortalGuard>} />
            <Route path="/services/bookings" element={<StaffPortalGuard><WorkerBookings /></StaffPortalGuard>} />
            <Route path="/services/my-profile" element={<StaffPortalGuard><StaffMyProfile /></StaffPortalGuard>} />
            <Route path="/services/change-request" element={<StaffPortalGuard><StaffChangeRequestPage /></StaffPortalGuard>} />
            <Route path="/services/leave-request" element={<StaffPortalGuard><StaffLeaveRequestPage /></StaffPortalGuard>} />
            <Route path="/services/salary-sheets" element={<StaffPortalGuard><StaffSalarySheetsPage /></StaffPortalGuard>} />
            <Route path="/services/reviews" element={<StaffPortalGuard><StaffReviewsPage /></StaffPortalGuard>} />
            <Route path="/services/care-history" element={<StaffPortalGuard><StaffCareHistoryPage /></StaffPortalGuard>} />
            <Route element={<ClientLayout />}>
              <Route path="/client/profile" element={<ClientProfile />} />
              <Route path="/client/bookings" element={<ClientBookings />} />
              <Route path="/client/service-requests" element={<ClientServiceRequests />} />
              <Route path="/client/patients" element={<ClientPatients />} />
              <Route path="/client/financial" element={<ClientFinancial />} />
              <Route path="/client/quotations" element={<ClientQuotations />} />
              <Route path="/client/invoices" element={<ClientInvoices />} />
              <Route path="/client/receipts" element={<ClientReceipts />} />
              <Route path="/client/statements" element={<ClientStatements />} />
              <Route path="/client/care-team" element={<ClientCareTeam />} />
              <Route path="/client/reviews" element={<ClientReviews />} />
              <Route path="/client/products" element={<ClientProducts />} />
            </Route>
            <Route path="/admin/dashboard" element={
              <AdminAuthProvider>
                <AdminDashboard />
              </AdminAuthProvider>
            } />
            <Route path="/admin/users" element={
              <AdminAuthProvider>
                <UserManagement />
              </AdminAuthProvider>
            } />
            <Route path="/admin/staff-management" element={
              <AdminAuthProvider>
                <StaffManagement />
              </AdminAuthProvider>
            } />
            <Route path="/admin/users/:clientId/detail" element={
              <AdminAuthProvider>
                <ClientDetailPage />
              </AdminAuthProvider>
            } />
            <Route path="/admin/users/:clientId/payments-made" element={
              <AdminAuthProvider>
                <ClientFinancialBreakdownPage metric="payments-made" />
              </AdminAuthProvider>
            } />
            <Route path="/admin/users/:clientId/total-invoiced" element={
              <AdminAuthProvider>
                <ClientFinancialBreakdownPage metric="total-invoiced" />
              </AdminAuthProvider>
            } />
            <Route path="/admin/users/:clientId/overdue-amount" element={
              <AdminAuthProvider>
                <ClientFinancialBreakdownPage metric="overdue" />
              </AdminAuthProvider>
            } />
            <Route path="/admin/users/:clientId/wallet-balance" element={
              <AdminAuthProvider>
                <ClientFinancialBreakdownPage metric="wallet" />
              </AdminAuthProvider>
            } />
            <Route path="/admin/proxy-user-management" element={
              <AdminAuthProvider>
                <ProxyUserManagement />
              </AdminAuthProvider>
            } />
            <Route path="/admin/service-requests" element={
              <AdminAuthProvider>
                <ServiceRequests />
              </AdminAuthProvider>
            } />
            <Route path="/admin/service-requests/:requestId/summary" element={
              <AdminAuthProvider>
                <ServiceRequestSummaryPage />
              </AdminAuthProvider>
            } />
            <Route path="/admin/proxy-service-requests" element={
              <AdminAuthProvider>
                <ProxyServiceRequest />
              </AdminAuthProvider>
            } />
            <Route path="/admin/termination-requests" element={
              <AdminAuthProvider>
                <TerminationRequests />
              </AdminAuthProvider>
            } />
            <Route path="/admin/upcoming-events" element={
              <AdminAuthProvider>
                <UpcomingEvents />
              </AdminAuthProvider>
            } />
            <Route path="/admin/quote-builder/:requestId?" element={
              <AdminAuthProvider>
                <ModularQuoteBuilder />
              </AdminAuthProvider>
            } />
            <Route path="/admin/modular-quote-builder/:requestId?" element={
              <AdminAuthProvider>
                <ModularQuoteBuilder />
              </AdminAuthProvider>
            } />
            <Route path="/admin/staff-roster" element={
              <AdminAuthProvider>
                <StaffRoster />
              </AdminAuthProvider>
            } />
            <Route path="/admin/staff/:staffProfileId/detail" element={
              <AdminAuthProvider>
                <StaffDetailPage />
              </AdminAuthProvider>
            } />
            <Route path="/admin/staff/:staffProfileId/v2" element={
              <AdminAuthProvider>
                <StaffDetailPageV2 />
              </AdminAuthProvider>
            } />
            <Route path="/admin/staff/:staffProfileId/total-earnings" element={
              <AdminAuthProvider>
                <TotalEarningsBreakdownPage />
              </AdminAuthProvider>
            } />
            <Route path="/admin/staff/:staffProfileId/current-earnings" element={
              <AdminAuthProvider>
                <CurrentEarningsBreakdownPage />
              </AdminAuthProvider>
            } />
            <Route path="/admin/workers" element={
              <AdminAuthProvider>
                <WorkerVerification />
              </AdminAuthProvider>
            } />
            <Route path="/admin/workers/:applicationId" element={
              <AdminAuthProvider>
                <WorkerVerificationDetailsPage />
              </AdminAuthProvider>
            } />
            <Route path="/admin/financial" element={
              <AdminAuthProvider>
                <Financials />
              </AdminAuthProvider>
            } />
            <Route path="/admin/bank-accounts" element={
              <AdminAuthProvider>
                <BankAccounts />
              </AdminAuthProvider>
            } />
            <Route path="/admin/vendors" element={
              <AdminAuthProvider>
                <VendorsPage />
              </AdminAuthProvider>
            } />
            <Route path="/admin/quotations" element={
              <AdminAuthProvider>
                <QuotationsPage />
              </AdminAuthProvider>
            } />
            <Route path="/admin/quotations/:quoteId" element={
              <AdminAuthProvider>
                <QuotationDetailsPage />
              </AdminAuthProvider>
            } />
            <Route path="/admin/bookings/:bookingId/staff-roster" element={
              <AdminAuthProvider>
                <BookingStaffRosterPage />
              </AdminAuthProvider>
            } />
            <Route path="/admin/bookings/:bookingId/staff-assignment" element={
              <AdminAuthProvider>
                <BookingStaffAssignmentPage />
              </AdminAuthProvider>
            } />
            <Route path="/admin/bookings/:bookingId/detail" element={
              <AdminAuthProvider>
                <BookingDetailPage />
              </AdminAuthProvider>
            } />
            <Route path="/admin/bookings/:bookingId/v2" element={
              <AdminAuthProvider>
                <BookingDetailPageV2 />
              </AdminAuthProvider>
            } />
            <Route path="/admin/reports" element={
              <AdminAuthProvider>
                <Reports />
              </AdminAuthProvider>
            } />
            <Route path="/admin/reports/sales-by-customer" element={
              <AdminAuthProvider>
                <SalesByCustomer />
              </AdminAuthProvider>
            } />
            <Route path="/admin/reports/sales_by_customer" element={
              <Navigate to="/admin/reports/sales-by-customer" replace />
            } />
            <Route path="/admin/reports/receivables-aging" element={
              <AdminAuthProvider>
                <ReceivablesAging />
              </AdminAuthProvider>
            } />
            <Route path="/admin/reports/payables-aging" element={
              <AdminAuthProvider>
                <PayablesAging />
              </AdminAuthProvider>
            } />
            <Route path="/admin/reports/profit-loss" element={
              <AdminAuthProvider>
                <ProfitLoss />
              </AdminAuthProvider>
            } />
            <Route path="/admin/reports/balance-sheet" element={
              <AdminAuthProvider>
                <BalanceSheet />
              </AdminAuthProvider>
            } />
            <Route path="/admin/bookings" element={
              <AdminAuthProvider>
                <Bookings />
              </AdminAuthProvider>
            } />
            <Route path="/admin/statements" element={
              <AdminAuthProvider>
                <Statements />
              </AdminAuthProvider>
            } />
            <Route path="/admin/invoices" element={
              <AdminAuthProvider>
                <AdminInvoicesPage />
              </AdminAuthProvider>
            } />
            <Route path="/admin/products" element={
              <AdminAuthProvider>
                <ProductsPage />
              </AdminAuthProvider>
            } />
            <Route path="/admin/advance-requests" element={
              <AdminAuthProvider>
                <AdvanceRequests />
              </AdminAuthProvider>
            } />
            <Route path="/admin/leave-requests" element={
              <AdminAuthProvider>
                <LeaveRequests />
              </AdminAuthProvider>
            } />
            <Route path="/admin/staff-history/:staffProfileId" element={
              <AdminAuthProvider>
                <StaffWorkingHistory />
              </AdminAuthProvider>
            } />
            <Route path="/admin/change-requests" element={
              <AdminAuthProvider>
                <ChangeRequestsPage />
              </AdminAuthProvider>
            } />
            <Route path="/admin/patients" element={
              <AdminAuthProvider>
                <PatientsPage />
              </AdminAuthProvider>
            } />
            <Route path="/admin/patients/:patientId/detail" element={
              <AdminAuthProvider>
                <PatientDetailPage />
              </AdminAuthProvider>
            } />
            <Route path="/admin/activity-log" element={
              <AdminAuthProvider>
                <ActivityLogPage />
              </AdminAuthProvider>
            } />
            <Route path="/admin/reviews" element={
              <AdminAuthProvider>
                <AdminReviewsPage />
              </AdminAuthProvider>
            } />
            <Route path="/admin/transactions" element={
              <AdminAuthProvider>
                <TransactionsPage />
              </AdminAuthProvider>
            } />
            <Route path="/admin/client-payments" element={
              <AdminAuthProvider>
                <ClientPaymentsLedgerPage />
              </AdminAuthProvider>
            } />
            <Route path="/admin/salaries" element={
              <AdminAuthProvider>
                <StaffSalariesPage />
              </AdminAuthProvider>
            } />
            <Route path="/admin/salary-sheets" element={
              <AdminAuthProvider>
                <SalarySheetLedgerPage />
              </AdminAuthProvider>
            } />
            <Route path="/admin/permissions" element={
              <AdminAuthProvider>
                <StaffPermissionsPage />
              </AdminAuthProvider>
            } />
            <Route path="/admin/roles" element={
              <AdminAuthProvider>
                <CustomRolesPage />
              </AdminAuthProvider>
            } />
            <Route path="/admin/internal-staff" element={
              <AdminAuthProvider>
                <InternalStaffPage />
              </AdminAuthProvider>
            } />
            <Route path="/admin/internal-staff/:id" element={
              <AdminAuthProvider>
                <InternalStaffProfilePage />
              </AdminAuthProvider>
            } />
            <Route path="/admin/internal-staff-salary" element={
              <AdminAuthProvider>
                <InternalStaffSalaryPage />
              </AdminAuthProvider>
            } />
            <Route path="/admin/internal-staff-salary/build/:sheetId" element={
              <AdminAuthProvider>
                <InternalStaffSalaryBuilder />
              </AdminAuthProvider>
            } />
            <Route path="/admin/active-sessions" element={
              <AdminAuthProvider>
                <ActiveSessionsPage />
              </AdminAuthProvider>
            } />
            <Route path="/admin/salespersons" element={
              <AdminAuthProvider>
                <SalespersonsPage />
              </AdminAuthProvider>
            } />
            <Route path="/admin/salespersons/:id" element={
              <AdminAuthProvider>
                <SalespersonDetailPage />
              </AdminAuthProvider>
            } />
            <Route path="/admin/bulk-import" element={
              <AdminAuthProvider>
                <BulkImportPage />
              </AdminAuthProvider>
            } />
            <Route path="/admin/staff-missing-bank-details" element={
              <AdminAuthProvider>
                <StaffMissingBankDetails />
              </AdminAuthProvider>
            } />
            <Route path="/admin/documents" element={
              <AdminAuthProvider>
                <DocumentsPage />
              </AdminAuthProvider>
            } />
            <Route path="/admin/whatsapp" element={
              <AdminAuthProvider>
                <WhatsAppInboxPage />
              </AdminAuthProvider>
            } />
            <Route path="/admin/notifications" element={
              <AdminAuthProvider>
                <NotificationsMessages />
              </AdminAuthProvider>
            } />
            <Route path="/admin/settings" element={
              <AdminAuthProvider>
                <Settings />
              </AdminAuthProvider>
            } />
            <Route path="/services/*" element={<Navigate to="/" replace />} />
            <Route path="/dashboard" element={<Navigate to="/login" replace />} />


            {/* Fallback */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
